export default __webpack_public_path__ + "static/media/EN.efc9c398.pdf";